export function getReportTitle(reportId) {
	switch (reportId) {
		case 'monthly_sale_report':
		case 'quarterly_sale_report':
		case 'annually_sale_report':
			return 'Sale Report for Insurance Company';

		case 'monthly_claim_report':
		case 'quarterly_claim_report':
		case 'annually_claim_report':
			return 'Receiving and Settling Claim Report for Insurance Company';

		case 'monthly_distribution_channel_report':
		case 'annually_distribution_channel_report':
			return 'Distribution Channels and Geographical Report for Insurance Company';

		case 'quarterly_financial_statements':
			return 'Financial Statements for Insurance Company';

		case 'quarterly_report_on_investment':
		case 'annually_report_on_investment':
			return 'Report on Investment for Insurance Company';

		case 'annually_audited_financial_statements':
			return 'Audited Financial Statement for Insurance Company';

		case 'annually_unaudited_financial_statements':
			return 'Unaudited Financial Statement for Insurance Company';

		default:
			return '';
	}
}

export function getQueryString(input) {
	const queryString = Object.keys(input)
		.map((key) => (input[key] ? key + '=' + input[key] : null))
		.filter(Boolean)
		.join('&');
	return queryString;
}
